<template>
    <div class="table-first-style">
        <div class="base-input ovf-hd conmon-top" style="margin-bottom: 10px;">
            <el-row class="search-title">
                <el-col :span="4" class="table-title" style="text-align: left">
                    <i class="el-icon-search" style="font-weight: bold;"></i>
                    <span class="order-list-search-span">筛选查询</span>
                </el-col>
                <el-col :span="20" class="text-align-right" style="text-align: right">
                    <el-button class="search-open-close" type="text" @click="hide=!hide" v-show="hide"> {{ hide? '收起查询':'展开查询' }}</el-button>
                    <el-button class="search-open-close" type="text" @click="hide=!hide" v-show="!hide">{{ hide? '收起查询':'展开查询' }}</el-button>
                    <i v-if="hide === true" class="el-icon-arrow-up search-open-close-i" @click="hide=!hide"></i>
                    <i v-if="hide === false" class="el-icon-arrow-down search-open-close-i" @click="hide=!hide"></i>
                    <el-button class="search-btn-new" type="primary" @click="searchWay">查询</el-button>
                </el-col>
            </el-row>
            <el-collapse-transition>
            <el-row class="search-content common-search-formtype" style="text-align: left;line-height: 60px" v-show="hide">
                    <el-form :inline="true" :model="search" label-width="95px" class="search-content-item">
                        <el-form-item label="业务区域名称：" label-width="115px">
                            <el-input v-model.trim="search.name" placeholder="请输入业务区域名称" clearable></el-input>
                        </el-form-item>
                    </el-form>
            </el-row>
            </el-collapse-transition>
        </div>
        <el-row class="search-title common-table-top" style="padding-right:0">
            <el-col :span="4" class="table-title" style="text-align: left">
                <i class="el-icon-document" style="font-weight: bold;"></i>
                <span>业务员区域列表</span>
            </el-col>
            <el-col :span="20" class="text-align-right">
                <el-button type="primary" class="add-btn btn-right" @click="toAdd('add')">新建</el-button>
            </el-col>
        </el-row>
        <el-table
                :data="tableData"
                v-loading="loading">
            <template slot="empty">
                <div class="newTableEmpty">暂无数据，去<span @click="toAdd('add')">新建</span></div>
            </template>
            <el-table-column
                    label="名称"
                    prop="name">
            </el-table-column>
            <el-table-column
                    label="编码"
                    prop="code">
            </el-table-column>
            <el-table-column
                    label="包含城市">
                <template slot-scope="scope">
                    <el-popover
                            placement="top-start"
                            width="200"
                            trigger="hover"
                            :content="scope.row.cityname">
                        <div slot="reference"  class="infoHide">
                            <div style="word-break: keep-all;white-space: nowrap;text-overflow: ellipsis;overflow: hidden;width: 100%;cursor: pointer;">
                    <span v-for="(item, index) in scope.row.areaList" :key="index" style="margin-right: 5px;">
                        {{item.province}}{{item.city}}{{item.county}}
                    </span>
                            </div>
                        </div>
                    </el-popover>

                </template>
            </el-table-column>
            <el-table-column
                    label="是否启用"
                    prop="status">
                <template slot-scope="scope">
                    <!-- 传值 1正常 0禁用 -->
<!--                    <div class="op-link" @click="switchChange(scope.row)">-->
<!--                        {{ scope.row.status === 1 ? '禁用':'启用' }}-->
<!--                    </div>-->
                    <el-switch
                            v-show="btnType.status_change"
                            @change="switchChange(scope.row)"
                            v-model="scope.row.status"
                            :active-value="activeValue"
                            :inactive-value="activeValueNo">
                    </el-switch>
                </template>
            </el-table-column>
            <el-table-column
                    label="操作"
                    width="150">
                <template slot-scope="scope">
                    <div class="op-link editColor" v-show="btnType.edit"  @click="toAdd('edit', scope.row.id)">
                        编辑
                    </div>
                    <div class="op-link" v-show="btnType.details" @click="toDetail(scope.row.id)">
                        详情
                    </div>
                    <div v-if="scope.row.status==0" v-show="btnType.del" class="op-link deleteColor" @click="confirmDelete(scope.row)">
                        删除
                    </div>
                </template>
            </el-table-column>
        </el-table>
        <div class="pos-rel p-t-20">
            <div class="table-foot">
                <el-pagination
                        class="table-foot-pagination totalPage"
                        background
                        @size-change="handleSizeChangeTotal"
                        @current-change="handleCurrentChangeTotal"
                        :page-size="search.pageSize"
                        :current-page="search.pageNum"
                        layout="total, prev, pager, next, jumper"
                        :total="totalCountTotal">
                </el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
import { getDepartment } from '@/api/customer.js'
import { businessAreaList, businessAreaDelete, changeStatusArea,butonsList,getMenId } from '@/api/analyse.js'
export default {
  data() {
    return {
      activeValueNo: 0,
      activeValue: 1,
      loading: true,
      hide: true,
      tableData: [],
      totalCountTotal: 0,
      currentPage: null,
      structures: [],
      limit: 10,
      page: 1,
      click: 1,
      search: {
        name: '',
        pageNum: 1,
        pageSize: 10
      },
      btnType:{
        'add':false,
        'edit':false,
        'details':false,
        'status_change':false,
        'del':false
      }
    }
  },
  methods: {
    // 跳转都编辑，添加
    toAdd(type, id) {
      if (type === 'add') {
        router.push('/home/administrative/businessAreaAddEdit?type=' + type)
      } else {
        router.push('/home/administrative/businessAreaAddEdit?type=' + type + '&id=' + id)
      }
    },
    queryBtnList(){
      var itemId = getMenId(this.$route.path)
       butonsList({systemCode: 'ZY_INTELLIQUOR',menuId:itemId})
        .then((res)=>{
          if(res.data.code == '200'){
            var btnList = this.btnType
            for(let i = 0, k = res.data.result.length; i < k; i ++){
              for(let m in btnList){
                if(res.data.result[i].perms.indexOf(m) != -1){
                  this.btnType[m] = true
                }
              }
            }
          }
        })
    },
    // 点击详情
    toDetail (id) {
      router.push('/home/administrative/businessAreaAddEdit?type=detail&id=' + id)
    },
    // 分页
    handleSizeChangeTotal(val) {
      this.search.pageSize = val
      this.load()
    },
    handleCurrentChangeTotal(page) {
      this.search.pageNum = page
      this.load()
    },
    // 点击查询
    searchWay () {
      this.search.pageNum = 1
      this.load()
    },
    // 启用禁用
    switchChange(item) {
      if (this.click === 1) {
        this.click = 0
        // item.status==0?item.status=1:item.status=0
        this.$nextTick(() => {
          let params = {
            id: item.id,
            status: item.status
          }
          changeStatusArea(params).then((res) => {
            if (res.data.code === '200') {
              _g.toastMsg('success', res.data.message)
              this.load()
              this.click = 1
            } else {
              _g.toastMsg('error', res.data.message)
            }
          })
        })
      }
    },
    // 查询加载
    load() {
      this.loading = true
      let params = this.search
      businessAreaList(params).then((res) => {
        if (res.data.code === '200') {
          res.data.result.list.map(item=> {
            let areaList = item.areaList
            item.cityname = ''
            areaList.map(it=> {
              item.cityname += (it.province + it.city + it.county) + ' '
            })
          })
          this.tableData = res.data.result.list
          this.totalCountTotal = res.data.result.total
        } else {
          this.tableData = []
          this.totalCountTotal = 0
        }
      })
      this.openLoading()
    },
    // 数据加载时的动画
    openLoading() {
      setTimeout(() => {
        this.loading = false
      }, 500)
    },
    // 删除成员
    confirmDelete(item) {
      this.$confirm('确认删除该业务区域?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        businessAreaDelete({id: item.id}).then((res) => {
          if (res.data.code === '200') {
            _g.toastMsg('success', '删除成功')
            this.load()
          } else {
            _g.toastMsg('error', res.data.data.message)
          }
        })
      }).catch((error) => {
      })
    },
    // 获取部门
    getAllOrgs() {
      getDepartment().then((res) => {
        if (res.data.code === 0) {
          res.data.data.list.unshift({ name: '全部', id: '' })
          this.structures = res.data.data.list
        }
      })
    },
    init() {
      this.load()
    }
  },
  created() {
    this.init()
    this.queryBtnList()
    // this.getAllOrgs()
  },
  computed: {
  },
  watch: {
  }
}
</script>
<style scoped>
</style>
